import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ErrorImg from 'src/assets/images/backgrounds/403-image.png';

const Error = () => (
    <Box
    display= "flex"
flexDirection = "column"
height = "100vh"
textAlign = "center"
justifyContent = "center"
backgroundColor = "rgb(194, 222, 240)"
    >
    <Container maxWidth="md" >
        <img src={ ErrorImg } alt = "404" style = {{ width: '100%', maxWidth: '500px' }} />
            < Typography align = "center" variant = "h1" mb = { 4} >
                Oops!!!
                </Typography>
                < Typography align = "center" variant = "h4" mb = { 4} >
                    Seems like you dont have access to this page
                        </Typography>
                        < Button color = "primary" variant = "contained" component = { Link } to = "/" disableElevation >
                            Go Back to Home
                                </Button>
                                </Container>
                                </Box>
);

export default Error;
